<template>
  <div class="user-permission-form">
    <h1 class="small-title justify-between" v-if="user.organizations.length > 0">Organizations <span>Admin</span></h1>
    <div class="organization" v-for="organization in user.organizations" :key="organization.id">
      <span>{{ organization.organization.name }}</span>
      <icon-button :icon="adminIcon(organization.isOrganizationAdmin)" @click="toggleOrganizationAdmin(organization)" />
    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'UserPermissionForm',
  components: { Picker },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showAddOrganizationDialog: false,
      formData: {
        organizationIds: []
      },
      nonMemberorganizations: [],
      isSystem: false
    }
  },
  computed: {
    userOrganizationIds () {
      return this.user.organizations.map(org => org.organization.id)
    }
  },
  methods: {
    adminIcon (isAdmin) {
      if (isAdmin) {
        return 'el-icon-star-on'
      } else {
        return 'el-icon-star-off'
      }
    },
    async toggleSystem () {
      try {
        const response = await this.$http.put(this.$api.users.update(this.user.id), data)
      } catch (error) {

      }
    },
    async toggleOrganizationAdmin (orgUser) {
      orgUser.isOrganizationAdmin = !orgUser.isOrganizationAdmin
      const data = { isOrganizationAdmin: orgUser.isOrganizationAdmin }

      try {
        const response = await this.$http.put(this.$api.organizations.users.update(orgUser.organization.id, this.user.id), data)
      } catch (error) {
        orgUser.isOrganizationAdmin = !orgUser.isOrganizationAdmin
        this.$message.error('Something went wront, try again.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .justify-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
  }

  .user-permission-form {
    display: flex;
    flex-direction: column;
  }

  .admin-checker {
    margin-bottom: 20px;
    align-self: center;
  }

  .organization {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    i {
      &:first-of-type {
        margin-left: -7px;
      }
    }

    span {
      margin-right: auto;
    }

    &:last-of-type {
      margin-bottom: 30px;
    }
  }

  h1 {
    margin-top: -20px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/UserPermissionForm.vue